import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@atomic';
import { COLOR_FONT_GRAY } from '@assets/color';

const postContentStyle = {
  padding: '10px',
  height: '40px',
  wordWrap: 'break-word',
};

function PostContent({ content = '', limit: maxLength, ...props }) {
  const [limit, setLimit] = useState(maxLength);
  const simpleContent = content.slice(0, limit);
  const isShowMore = content.length > limit;

  const onClickMore = () => {
    setLimit(content.length);
  };

  return (
    <Text paragraph style={postContentStyle} {...props}>
      {simpleContent}
      {isShowMore && (
        <Text textColor={COLOR_FONT_GRAY} onClick={onClickMore}>
          ...더보기
        </Text>
      )}
    </Text>
  );
}

PostContent.propTypes = {
  content: PropTypes.string,
  limit: PropTypes.number,
};

export default PostContent;
